import React, { Component } from 'react';

export class Image extends Component {

    render() {
        return (
            <img alt="whateveryouwant" src={this.props.src} className={this.props.class} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/util/Image.js